import { h } from './dom';

export function Marquee(): HTMLElement {
  const track = h('div', { class: 's-marquee__track' });
  for (let i = 0; i < 4; i++) {
    track.append(
      h('span', {}, 'BUILD DAMN GOOD SOFTWARE'),
      h('span', { class: 'star' }, '✱'),
      h('span', {}, h('em', {}, 'SHIP IT.')),
      h('span', { class: 'star' }, '✱'),
    );
  }
  return h('div', { class: 's-marquee' }, track);
}
